import { render, staticRenderFns } from "./UpdateModelDialog.vue?vue&type=template&id=88a6ada6&scoped=true"
import script from "./UpdateModelDialog.vue?vue&type=script&lang=js"
export * from "./UpdateModelDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateModelDialog.vue?vue&type=style&index=0&id=88a6ada6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a6ada6",
  null
  
)

export default component.exports